'use strict';

var toastr = require('toastr');
var _ = require('lodash');
function FlightManagementParallelizeDataRetrieverService($q, queryService, softLimitService, app, flightManagementConstants, dataRetrieverConstantsService, liteDataService) {
  function getCount(url, path, filterBuilder, screenState) {
    var filter = filterBuilder(null, false, screenState);
    return retrieveData(url, 'flattenedLegCabins/count', filter);
  }
  function orchestrate(url, path, filterBuilder, propertyToMerge, screenState) {
    return function (countResponse) {
      var orchestration = {
        url: url,
        path: path,
        screenState: screenState,
        partials: [],
        localSort: false,
        propertyToMerge: propertyToMerge
      };
      if (queryService.canParallelize(countResponse.totalCount)) {
        var originalFilter = filterBuilder(null, true, screenState);
        var splittedRules = queryService.splitRules(originalFilter.filter.rules);
        var departureDateRules = queryService.buildDataRanges(splittedRules.departureDate);
        _.each(departureDateRules, function (departureDateRule) {
          var newFilter = _.extend({}, originalFilter);
          newFilter.filter = newFilter.filter.clone();
          newFilter.filter.clear();
          newFilter.filter.addCriteria(splittedRules.fixed);
          newFilter.filter.addCriteria(departureDateRule);
          orchestration.partials.push(newFilter);
        });
      } else {
        if (countResponse.totalCount > 0) {
          orchestration.partials.push(filterBuilder(null, false, screenState));
        }
      }
      return orchestration;
    };
  }
  function retrievePartials(orchestration) {
    return $q.all(_.map(orchestration.partials, function (partialFilter) {
      partialFilter.filter = partialFilter.filter.toRSQL ? partialFilter.filter.toRSQL() : partialFilter.filter;
      return retrieveData(orchestration.url, orchestration.path, partialFilter);
    }));
  }
  function mergeResponses(propertyToMerge) {
    return function (partialResponses) {
      var mergedResponse = {};
      mergedResponse[propertyToMerge] = [];
      return _.reduce(partialResponses, function (result, response) {
        result[propertyToMerge] = _.concat(result[propertyToMerge], response[propertyToMerge]);
        return result;
      }, mergedResponse);
    };
  }
  function retrieveData(url, path, filter) {
    return liteDataService.get(url + '/' + path, filter);
  }
  function getSoftLimit() {
    var queryConfig = _.find(app.dataRetrievalConfigs, {
      attributes: {
        view: dataRetrieverConstantsService.FLIGHT_SCREEN,
        mode: flightManagementConstants.GRIDS.FLIGHT_SUMMARY
      }
    });
    return _.get(queryConfig, ['properties', 'softLimit']);
  }
  function parallelize(url, path, filterBuilder, propertyToMerge, screenState) {
    var deferWrapResponse = $q.defer();
    try {
      getCount(url, path, filterBuilder, screenState).then(function (countResponse) {
        return softLimitService.confirm(countResponse.totalCount, getSoftLimit(), countResponse)["catch"](function () {
          return $q.when({
            totalCount: 0
          });
        });
      })["catch"](function (countResponse) {
        if (countResponse.status === 413) {
          return $q.when({
            totalCount: 0
          });
        }
      }).then(orchestrate(url, path, filterBuilder, propertyToMerge, screenState)).then(retrievePartials).then(mergeResponses(propertyToMerge)).then(function (mergedResponse) {
        deferWrapResponse.resolve(mergedResponse);
      })["catch"](function () {
        toastr.error('One or more parallel request fail.');
        deferWrapResponse.reject();
      });
    } catch (e) {
      deferWrapResponse.reject(e);
    }
    return deferWrapResponse.promise;
  }
  return {
    parallelize: parallelize
  };
}
FlightManagementParallelizeDataRetrieverService.$inject = ['$q', 'FlightManagementParallelizeQueryService', 'SoftLimitService', 'App', 'FlightManagementConstants', 'DataRetrieverConstantsService', 'LiteDataService'];
module.exports = FlightManagementParallelizeDataRetrieverService;